import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileApi"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 6.75H3C2.17157 6.75 1.5 7.42157 1.5 8.25V17.25H3V13.5H6V17.25H7.5V8.25C7.5 7.42157 6.82843 6.75 6 6.75ZM3 12V8.25H6V12H3ZM16.5 8.25H18.75V15.75H16.5V17.25H22.5V15.75H20.25V8.25H22.5V6.75H16.5V8.25ZM10.5 17.25H9V6.75H13.5C14.3284 6.75 15 7.42157 15 8.25V12C15 12.8284 14.3284 13.5 13.5 13.5H10.5V17.25ZM10.5 12H13.5V8.25H10.5V12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileApi.vue"]]);
